import { t } from 'i18next'
import React, { useEffect, useState } from 'react'
import ReactPaginate from 'react-paginate'

const Pagination = (data) => {
  const limit = data.data?.limit ?? 0
  const total_pages = data.data?.total_pages ?? 0
  const page = data.data?.page ?? 0
  const onLimitChange = data?.onLimitChange ? data.onLimitChange : null
  const itemsPerPage = limit
  const [pageCount, setPageCount] = useState(0)
  // const [itemsPerPage, setItemsPerPage] = useState(5)

  const totalData = [
    { value: 5, label: `${t('title.per_page')} 5 ${t('form.data')}` },
    { value: 10, label: `${t('title.per_page')} 10 ${t('form.data')}` },
    { value: 50, label: `${t('title.per_page')} 50 ${t('form.data')}` },
    { value: 100, label: `${t('title.per_page')} 100 ${t('form.data')}` },
    ...(data?.thousandsDataLimit
      ? [{ value: 1000, label: `${t('title.per_page')} 1000 ${t('form.data')}` }]
      : []),
  ]

  useEffect(() => {
    setPageCount(total_pages)
  }, [itemsPerPage, total_pages])

  const handlePageClick = (event) => {
    const val = event.selected + 1
    data.onChangePage(val)
    window.scrollTo({ top: 50, behavior: 'smooth' })
  }
  const handleLimitChange = (event) => {
    // setItemsPerPage(event.target.value)
    onLimitChange(event.target.value)
    window.scrollTo({ top: 50, behavior: 'smooth' })
  }

  const NextLabel = () => {
    return <i className="fa fa-angle-right"></i>
  }

  const PreviousLabel = () => {
    return <i className="fa fa-angle-left"></i>
  }

  const PaginateComponent = () => {
    return (
      <ReactPaginate
        breakLabel="..."
        breakClassName="page-item"
        breakLinkClassName="page-link"
        nextLabel={<NextLabel />}
        previousLabel={<PreviousLabel />}
        onPageChange={handlePageClick}
        pageRangeDisplayed={data.data?.range || 5}
        pageCount={pageCount}
        renderOnZeroPageCount={null}
        containerClassName="pagination justify-content-center row"
        pageClassName="page-item"
        pageLinkClassName="page-link"
        previousClassName="page-item"
        previousLinkClassName="page-link"
        nextClassName="page-item"
        nextLinkClassName="page-link"
        activeClassName="active"
        forcePage={page - 1}
      />
    )
  }

  return (
    <>
      {onLimitChange ? (
        <div className="d-flex row justify-content-between">
          <div className=" col-24 col-md-4 mr-2 mt-2 mt-lg-0">
            <select
              className="form-control height-40 py-2 px-3"
              name="limit"
              required
              value={itemsPerPage}
              onChange={handleLimitChange}
            >
              {totalData.map((row, index) => {
                return (
                  <option key={index} value={row.value}>
                    {row.label}
                  </option>
                )
              })}
            </select>
          </div>
          <div className=" col-24 col-md-20 mr-2 mt-2 mt-lg-0">{PaginateComponent()}</div>
        </div>
      ) : (
        PaginateComponent()
      )}
    </>
  )
}

export default Pagination
